import React from "react";
import {digits, filterBalls, onChangeDigits, onMouseEnter, onMouseLeave} from "../../utility/General";
import dudoan from "../../assets/images/dudoan.png";


const FilterBall = ({activeDigit, indexResult, setActiveDigit}) => {

    return <table cellSpacing="0" cellPadding="0" className="boxBottom">
        <tbody>
        <tr className="filter-balls">
            <td className="config_Bangketqua_list">
                {digits.map((e, i) => {
                    let active = e.value === activeDigit ? " active-digit" : "";
                    return <div key={i}
                                onClick={_ => onChangeDigits(indexResult, e.value, activeDigit, setActiveDigit)}
                                className={`config_Item config_Item4 ${active}`}>
                        {e.label}
                    </div>
                })}
            </td>
            {filterBalls.map((_, i) => {
                return <td onMouseLeave={() => onMouseLeave(indexResult, activeDigit)}
                           onMouseEnter={() => onMouseEnter(indexResult, i, activeDigit)}
                           key={i} className="filter-ball">
                    <div>{i}</div>
                </td>
            })}
            <td className="sodudoan">
                <div><img src={dudoan} alt="dudoan"/>
                </div>
            </td>
            <td className="showLoto">
                Xem Bảng Loto
            </td>
        </tr>
        </tbody>
    </table>
}

export default FilterBall;